/* @ngInject */
const areaButtons = (
  icons,
  areaGo,
  areaAsk,
  areaLabels
) => {
  const self = {}

  self.search = {
    labels: areaLabels.search,
    icon: icons.search,
    action: areaGo.consult,
    display: _nature => _nature === 'tables',
  }

  self.edit = {
    labels: areaLabels.edit,
    icon: icons.edit,
    action: areaGo.edit,
    display: _nature => true,
  }

  self.delete = {
    labels: areaLabels.delete,
    icon: icons.delete,
    action: areaAsk.delete,
    display: _nature => _nature === 'action',
    class: _area => 'retour',
  }

  return self
}
export default areaButtons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/resources/buttons.resource.js